var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaUserMd = function SvgFaUserMd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -256 1792 1792",
    id: "svg3166",
    width: "100%",
    height: "100%",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,205.01695,1300.6102)",
    id: "g3168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 384,192 q 0,-26 -19,-45 -19,-19 -45,-19 -26,0 -45,19 -19,19 -19,45 0,26 19,45 19,19 45,19 26,0 45,-19 19,-19 19,-45 z m 1024,-61 q 0,-121 -73,-190 -73,-69 -194,-69 H 267 Q 146,-128 73,-59 0,10 0,131 0,199 5.5,262 11,325 29.5,400 48,475 77,532.5 106,590 158,635.5 210,681 278,696 256,644 256,576 V 373 Q 198,353 163,303 128,253 128,192 128,112 184,56 240,0 320,0 q 80,0 136,56 56,56 56,136 0,61 -35.5,111 -35.5,50 -92.5,70 v 203 q 0,62 25,93 132,-104 295,-104 163,0 295,104 25,-31 25,-93 V 512 Q 918,512 843,437 768,362 768,256 v -89 q -32,-29 -32,-71 0,-40 28,-68 28,-28 68,-28 40,0 68,28 28,28 28,68 0,42 -32,71 v 89 q 0,52 38,90 38,38 90,38 52,0 90,-38 38,-38 38,-90 v -89 q -32,-29 -32,-71 0,-40 28,-68 28,-28 68,-28 40,0 68,28 28,28 28,68 0,42 -32,71 v 89 q 0,68 -34.5,127.5 -34.5,59.5 -93.5,93.5 0,10 0.5,42.5 0.5,32.5 0,48 -0.5,15.5 -2.5,41.5 -2,26 -7,47 -5,21 -13,40 68,-15 120,-60.5 52,-45.5 81,-103 29,-57.5 47.5,-132.5 18.5,-75 24,-138 5.5,-63 5.5,-131 z m -320,893 Q 1088,865 975.5,752.5 863,640 704,640 545,640 432.5,752.5 320,865 320,1024 320,1183 432.5,1295.5 545,1408 704,1408 863,1408 975.5,1295.5 1088,1183 1088,1024 z",
    id: "path3170",
    style: {
      fill: "currentColor"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaUserMd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fa-user-md.0c4312d9.svg";
export { ForwardRef as ReactComponent };